import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

import { OnInit, ViewChild } from "@angular/core";
import { MiscService } from "../../services/misc.service";
import { UserService } from "../../services/user.service";
import { GlobalCfgService } from "../../services/globalcfg.service";
import { FormGroup, FormControl } from "@angular/forms";
import { FileUploadService } from "../../services/file-upload.service";
import { EventBusService } from "../../services/event-bus.service";
import { Utils } from "../../services/utils";
import { environment } from "../../environments/environment";
import { MessageService } from "../../services/message.service";
import { MatDialog } from "@angular/material";
import { Subject } from 'rxjs';

@Component({
  selector: "rm-edit-profile",
  templateUrl: "./edit-profile.component.html",
  styleUrls: ["./edit-profile.component.css"]
})
export class EditProfileComponent implements OnInit, OnChanges {

  isReadOnly: boolean = true;

  public uploader;
  dashboardLink = "";
  user: any;
  countries: any[];
  states: any[];
  cities: any[];

  selectedCountry;
  selectedState;
  selectedCity;
  firstName;
  lastName;
  dob;
  gender;
  address;
  pincode;
  about;
  photoUrl;

  editProfileFormGroup = new FormGroup({
    id: new FormControl(),
    firstName: new FormControl(),
    lastName: new FormControl(),
    address: new FormControl(),
    countryId: new FormControl(),
    countryName: new FormControl(),
    stateId: new FormControl(),
    stateName: new FormControl(),
    city: new FormControl(),
    pincode: new FormControl(),
    userId: new FormControl(),
    mobile: new FormControl(),
    email: new FormControl()
  });

  attachment: any;

  dialogWidth: "350px";
  subscriptions: any[] = [];

  public statesSource = new Subject<any>();
  public statesValue$ = this.statesSource.asObservable();

  public countriesSource = new Subject<any>();
  public countriesValue$ = this.countriesSource.asObservable();

  constructor(
    private dialog: MatDialog,
    private miscService: MiscService,
    private userService: UserService,
    private globalCfgService: GlobalCfgService,
    private uploadService: FileUploadService,
    private busService: EventBusService,
    private utils: Utils,
    private msgService: MessageService
  ) {}

  ngOnInit() {
    //keep the original object to restore values
    this.subscriptions.push(this.statesValue$.subscribe(
      ()=> {
        this.user = this.globalCfgService.getFullUserObj();
        // if (!this.user) {
          this.userService.getUserDetail(this.globalCfgService.getLoggedInUser().userId).subscribe(
            (response: any) => {
              this.globalCfgService.setFullUserObj(response);
              this.user = response;
    
              if (response.role == 'brand-owner') {
                window.localStorage.setItem('gcp', response.gcp);
              }
    
              this.userService.getUserContact(this.user['gcp']).subscribe(
                (response)=> {
                  var data;
                  response['data'].forEach(contact => {
                    if(contact.userId == this.globalCfgService.getLoggedInUser().userId) {
                      data = contact;
                    }
                  });
                  this.selectedCountry = data["countryId"];
                  this.selectedState = data["stateId"];
                  // this.editProfileFormGroup.setValue(data);
                  // setTimeout(() => {
                    this.updateProfile(data);
                  // }, 2000);
                  // this.updateProfile(data);
                }
              );
                        
            });
        // }
      }
    ));

    this.subscriptions.push(this.countriesValue$.subscribe(
      ()=> this.loadStates(this.selectedCountry)
    ));
    this.loadCountries();

    this.uploader = this.uploadService.getUploader(environment.profilePicsContainer);

    this.subscriptions.push(this.busService.profilepicFetchedValue$.subscribe(
      userDetail => {
        this.user["photoUrl"] = userDetail["photoUrl"];
      }
    ));

    setTimeout(() => {
      // this.updateProfile();
    }, 1000);
  }

  private updateProfile(data) {
    this.editProfileFormGroup.setValue({
      id: data.id,
      userId: data.userId, 
      firstName: data.firstName,
      lastName: data.lastName,
      address: data.address,
      pincode: data.pincode,
      mobile: data.mobile,
      email: data.email,
      countryName: data.countryId
      ? this.utils.getObject(
          "id",
          data.countryId,
          this.countries
        ).name
      : null,
      countryId: data.countryId
        ? this.utils.getObject(
            "id",
            data.countryId,
            this.countries
          ).code
        : null,
      stateName: data.stateId
      ? this.utils.getObject(
          "id",
          data.stateId,
          this.states
        ).name
      : null,
      stateId: data.stateId
        ? this.utils.getObject(
            "id",
            data.stateId,
            this.states
          ).code
        : null,
      city: data.city
    });
  }

  onFileSelected() {
    this.uploader.response.subscribe(
      response => {

        this.attachment = JSON.parse(response)["result"]["files"]["file"][0];
        // var path =
        //   "/uploads/" + this.attachment.container + "/" + this.attachment.name;
        var path = this.attachment.providerResponse.location;

        this.userService
          .updateUserPhoto(this.user["id"], path)
          .subscribe(
            response => {
              this.busService.profilepicSource.next(response);
            },
            error => {
              console.log("Service error:", error);
            }
          );
      },
      error => {
        console.log("File upload error:", error);
      }
    );
  }

  getLocation() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        success => {
          let GEOCODING = `${environment.geoCodeUrl}${success.coords.latitude}%2C${success.coords.longitude}&key=${environment.geoCodeAPI}`;

          this.userService.getLocation(GEOCODING).subscribe(location => {
            let pincodeValue,
              addressArray = location["results"][0].address_components;
            let addressValue = location["results"][0].formatted_address;
            addressArray.forEach(address => {
              if ("country" == address.types[0]) {
                this.selectedCountry = address.short_name;
              } else if ("postal_code" == address.types[0]) {
                pincodeValue = address.short_name;
              } else if ("administrative_area_level_1" == address.types[0]) {
                this.selectedState = address.short_name;
              } else if ("administrative_area_level_2" == address.types[0]) {
                this.selectedCity = address.short_name;
              }
            });

            this.loadStates(this.selectedCountry);
            this.editProfileFormGroup.controls.pincode.setValue(pincodeValue);
            console.log("#posttal " + pincodeValue);
            this.editProfileFormGroup.controls.countryId.setValue(
              this.selectedCountry
            );
            console.log("#country " + this.selectedCountry);
            this.editProfileFormGroup.controls.address.setValue(addressValue);
          });
        },
        error => {}
      );
    }
  }

  onSubmit(profile) {
    let profileObj = Object.assign({}, profile);
    profileObj.userId = this.user["id"];

    var country = this.utils.getObject(
      "code",
      profile.countryId,
      this.countries
    );
    if (country) {
      profileObj.countryId = country.id;
    }

    var state = this.utils.getObject("code", profile.stateId, this.states);
    if (state) {
      profileObj.stateId = state.id;
    }

    if (profileObj.id) {
      this.userService.updateContact(profileObj).subscribe(
        (response: any)=> {
          this.msgService.showSuccess(this.msgService.contactUpdate);
          delete response.createdon;
          delete response.modifiedon;
          this.updateProfile(response);
          // this.editProfileFormGroup.setValue(response);
          this.isReadOnly = true;
        }
      );
    } else {
      delete profileObj.id;
    this.userService.createContact(profileObj).subscribe(
      (response: any)=> {
        this.msgService.showSuccess(this.msgService.contactSave);
        delete response.createdon;
        delete response.modifiedon;
        this.editProfileFormGroup.setValue(response);
        this.isReadOnly = true;
      }
    );
    }
    
  }

  onStateChange(stateId) {
    this.editProfileFormGroup.controls.city.setValue(null);
    this.editProfileFormGroup.controls.pincode.setValue(null);
    this.editProfileFormGroup.controls.address.setValue(null);
    var state = this.utils.getObject(
      "code",
      stateId,
      this.states
    );

    this.editProfileFormGroup.controls.stateName.setValue(state.name);
  }

  onChangeCountry(countryId) {
    this.selectedState = null;
    this.states = [];
    this.cities = [];
    this.editProfileFormGroup.controls.stateId.setValue(this.selectedState);
    this.editProfileFormGroup.controls.city.setValue(null);
    this.editProfileFormGroup.controls.pincode.setValue(null);
    this.editProfileFormGroup.controls.address.setValue(null);
    var country = this.utils.getObject(
      "code",
      countryId,
      this.countries
    );

    this.editProfileFormGroup.controls.countryName.setValue(country.name);
    
    this.loadStates(country.id);
  }

  private loadCountries() {
    this.miscService.getCountries().subscribe(
      (response: any[]) => {
        this.countries = response["data"];
        this.selectedCountry = this.countries[0].id;

        this.countriesSource.next();
      },
      error => {
        console.log("Service failed:", error);
      }
    );
  }

  private loadStates(countryId) {
    this.miscService.getStates(countryId).subscribe(
      (response: any[]) => {
        this.states = response["data"];

        this.statesSource.next();
      },
      error => {
        console.log("Service failed:", error);
      }
    );
  }

  private getContact(userId) {
    this.userService.getUserContact(userId).subscribe(
      (contact)=> {
        // this.editProfileFormGroup.setValue(contact);
        this.updateProfile(contact);
      }
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("changes:", changes);
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  cancel() {
    this.isReadOnly = true;
    this.statesSource.next();
  }
}
